import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/encounter";

export const pagingMedicationRecordSheet = (searchObject) => {
  var url = API_PATH + "/get-page-etb-patient-encounter";
  return axios.post(url, searchObject);
};

export const getViewEncounterById = (list) => {
  var url = API_PATH + "/get-view-encounter-by-id";
  return axios.post(url, list);
};
